export type PeriodKey =
  | "30_days"
  | "6_months"
  | "12_months"
  | "2_years"
  | "5_years"
  | "always"
  | "custom";

export interface PeriodOption {
  title: string;
  value: PeriodKey;
}

export const PERIOD_OPTIONS: Record<PeriodKey, PeriodOption> = {
  "30_days": { title: "30 dias", value: "30_days" },
  "6_months": { title: "6 meses", value: "6_months" },
  "12_months": { title: "12 meses", value: "12_months" },
  "2_years": { title: "2 anos", value: "2_years" },
  "5_years": { title: "5 anos", value: "5_years" },
  always: { title: "Todo Período", value: "always" },
  custom: { title: "Intervalo personalizado", value: "custom" },
};
